import { useCallback } from 'react'

import { useBulkUnlockMutation } from '@/rtkApi/mddApiV2'
import { logError } from '@/utils/errorHandling'

import { useTreePanelOperations } from '../../../TreePanelContext'
import { useBatchEditContext } from '../context/BatchEditContext'
import { ActionTypeEnum } from '../context/types'

export const useOnUnlock = () => {
	const [bulkUnlock] = useBulkUnlockMutation()
	const { refreshSystemsSilent } = useTreePanelOperations()

	const {
		state: { selectedStructures, locking },
		dispatch: dispatchContext,
	} = useBatchEditContext()

	const onUnlock = useCallback(async () => {
		if (locking) {
			return
		}

		dispatchContext({ type: ActionTypeEnum.SET, state: { locking: true } })

		const nodesToUnlock: number[] = []

		for (const node of selectedStructures) {
			if (node.lockTime && node.id) {
				nodesToUnlock.push(node.id)
			}
		}

		if (nodesToUnlock.length > 0) {
			await bulkUnlock({ id: nodesToUnlock }).unwrap()
			refreshSystemsSilent().catch((e) =>
				logError(e, { operation: 'useOnUnlock.refreshSystemsSilent' }),
			)
		}

		dispatchContext({ type: ActionTypeEnum.SET, state: { locking: false } })
	}, [bulkUnlock, dispatchContext, locking, refreshSystemsSilent, selectedStructures])

	return onUnlock
}
